import quickFetch from 'quick-fetch';
import stableStringify from 'fast-json-stable-stringify';
import { batchScheduler } from 'batch-promise';
import { createBatchedEarlyRequester } from '../../quickFetch/createBatchedEarlyRequester';
import { promisifyEarlyRequest } from '../../quickFetch/promisifyEarlyRequest';
import { keyBy } from '../../utils/keyBy';
import { normalizeVariables } from './sortFilterGroups';
const toSimpleProperties = properties => {
  var _ref;
  return (_ref = properties && keyBy(properties, ({
    name
  }) => name, ({
    name,
    value,
    sourceId,
    source,
    timestamp
  }) => ({
    name,
    value: value !== null && value !== void 0 ? value : undefined,
    sourceId: sourceId !== null && sourceId !== void 0 ? sourceId : undefined,
    source: source !== null && source !== void 0 ? source : undefined,
    timestamp: timestamp !== null && timestamp !== void 0 ? timestamp : undefined
  }))) !== null && _ref !== void 0 ? _ref : {};
};
const throwOnValidationErrors = (crmObjectsSearch, errors) => {
  // TODO: Need to double-check this logic
  const maybeError = crmObjectsSearch.validationErrors.length > 0 && new Error(crmObjectsSearch.validationErrors[0].message) || errors && errors.length > 0 && new Error(errors[0].message);
  if (maybeError) {
    throw maybeError;
  }
};
export const handleGQLResult = (objectTypeId, result, errors) => {
  throwOnValidationErrors(result.crmObjectsSearch, errors);
  return Object.assign({}, result.crmObjectsSearch, {
    results: result.crmObjectsSearch.results.map(({
      objectId,
      properties,
      currentUserPermissions
    }) => {
      const object = {
        objectId,
        objectTypeId,
        currentUserPermissions,
        properties: toSimpleProperties(properties)
      };
      return object;
    })
  });
};
// `importGql` inlines the query as a string at build time (paired with the
// consumer's gql webpack plugin), keeping the graphql printer and parsed AST
// out of the early-request path.
const CRM_SEARCH_GQL_QUERY = importGql('HsEntitiesCrmSearch');
const scheduler = batchScheduler().read().identity(({
  operation,
  variables
}) => stableStringify({
  operationName: operation.operationName,
  variables
})).partition(() => 'crmSearchGql').execute(batch => {
  const entries = Object.entries(batch);
  return promisifyEarlyRequest({
    url: quickFetch.getApiUrl('/graphql/crm'),
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify(entries.map(([, {
      operation,
      variables
    }]) => ({
      operationName: operation.operationName,
      query: operation.query,
      variables
    }))),
    dataType: 'json'
  }).then(results => Object.fromEntries(entries.map(([id], index) => [id, results[index]])));
}).extract(({
  response,
  input,
  identity
}) => {
  const {
    data,
    errors
  } = response[identity];
  return handleGQLResult(input.variables.objectTypeId, data, errors);
}).immediate();
const {
  request,
  consume
} = createBatchedEarlyRequester('hs-resources:crmSearch-early', scheduler);
export const earlyRequest = ({
  variables
}) => request({
  operation: CRM_SEARCH_GQL_QUERY,
  variables: normalizeVariables(variables, 'early')
});
export const consumeEarlyCrmSearch = variables => consume({
  operation: CRM_SEARCH_GQL_QUERY,
  variables: normalizeVariables(variables, 'standard')
});